import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { fetchCalendar } from '@/redux/store/actions/generalActions';
import { calendarSelector } from '../../../helpers/props';
import { adjustJalaliMonth, formatPersianDates } from '@/helpers/dateManager';
export type CalendarPricingType = {
  houseCalendarData: any;
  handleMultiCalendarChange: any;
  calendarLoading?: boolean;
};
const useProduct = (id?: string | number) => {
  const dispatch = useDispatch();
  const router = useRouter();
  const houseId = (id ?? router.query.id) as string;
  const houseCalendarData = useSelector(state => calendarSelector(state));
  const [calendarLoading, setCalendarLoading] = useState(true);
  useEffect(() => {
    if (process.env.OFFLINE_MODE === 'true') {
      setCalendarLoading(false);
      return;
    }
    const date = new Date();
    const firstDayFormatted = formatPersianDates(date);
    const {
      year: newYear,
      month: newMonth
    } = adjustJalaliMonth(+firstDayFormatted.year, +firstDayFormatted.month, 12);
    dispatch(fetchCalendar({
      houseId,
      fromDate: `${firstDayFormatted.year}-${firstDayFormatted.month}-01`,
      toDate: `${newYear}-${+newMonth < 10 ? `0${newMonth}` : newMonth}-01`
    }, setCalendarLoading));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [houseId]);
  const handleMultiCalendarChange = (fromDate: string | number, toDate: string | number) => {
    if (process.env.OFFLINE_MODE === 'true') return;
    dispatch(fetchCalendar({
      houseId,
      fromDate,
      toDate
    }));
  };
  return {
    calendarPricing: {
      houseCalendarData,
      handleMultiCalendarChange,
      calendarLoading
    }
  };
};
export default useProduct;